
<template>
  <div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
    </base-header>
    <div class="container-fluid mt--9" style="margin-top:-9">
          <div class="card resources-main-container">
            <div class="resources-header-sect">
                <span class="re-primary-text">Buscar recursos ({{ images.length }})</span>
                <a class="re-cta-button" href="https://forms.gle/hpk2shEBF2r8qp8AA" target="_blank">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="16" viewBox="0 0 13 14" fill="none">
                        <g clip-path="url(#clip0_40_3567)">
                            <path d="M11.7915 5.76399C11.4316 5.76978 11.1449 6.06665 11.1507 6.42651C11.1565 6.79722 11.1616 7.14984 11.1652 7.48508L10.1356 6.53005C9.79453 6.21363 9.34924 6.04927 8.91335 6.08041C8.38624 6.11806 8.04086 6.4323 7.92719 6.53511C7.479 6.94276 5.40312 8.98315 2.43883 11.9634C2.3686 12.0343 2.31864 12.1176 2.2875 12.2059H2.15935C2.03626 12.19 1.87045 12.1437 1.72564 12.0177C1.40198 11.7375 1.44398 11.2596 1.44615 11.2393C1.44832 11.214 1.44977 11.1886 1.44905 11.1633C1.35637 6.62852 1.35854 3.7779 1.40126 2.96479C1.40633 2.875 1.41574 2.6882 1.51566 2.5738C1.64237 2.42898 1.94358 2.36309 2.34398 2.39278C2.35774 2.3935 2.3715 2.39423 2.38525 2.39423L7.10031 2.44274C7.10031 2.44274 7.10466 2.44274 7.10683 2.44274C7.46379 2.44274 7.75486 2.15529 7.75848 1.79761C7.7621 1.43775 7.4732 1.14306 7.11335 1.13944L2.41856 1.09093C1.59169 1.03373 0.941482 1.24949 0.534562 1.71506C0.137778 2.1705 0.108816 2.71716 0.0994032 2.89672C0.045823 3.89954 0.0646485 7.21718 0.145019 11.1582C0.126193 11.4283 0.124021 12.3544 0.871972 13.0031C1.28686 13.363 1.74663 13.4759 2.0587 13.5071C2.08042 13.5092 2.10215 13.51 2.12387 13.51H2.12676L10.2449 13.4709C10.995 13.4781 11.5974 13.2457 11.9906 12.7982C12.4496 12.2769 12.4605 11.6499 12.4649 11.382C12.4735 10.8954 12.4974 9.09755 12.4533 6.40406C12.4475 6.0442 12.1499 5.76037 11.7908 5.76327L11.7915 5.76399ZM11.1616 11.3595C11.1579 11.5608 11.1434 11.7881 11.0117 11.9373C10.8307 12.1429 10.4599 12.1697 10.2536 12.1676C10.25 12.1676 10.2463 12.1676 10.2434 12.1676L4.04552 12.1972C6.54569 9.68983 8.39782 7.86883 8.80402 7.49956C8.83805 7.46842 8.92928 7.38588 9.00603 7.38009C9.09437 7.37285 9.19284 7.43294 9.24932 7.48508L10.8828 8.9998C10.9682 9.07945 11.0696 9.13086 11.176 9.15548C11.1782 10.3038 11.1673 11.0677 11.1623 11.3588L11.1616 11.3595Z" fill="white"/>
                            <path d="M2.48157 5.4287C2.48157 6.49524 3.34899 7.36338 4.41552 7.36338C5.48206 7.36338 6.35021 6.49596 6.35021 5.4287C6.35021 4.36144 5.48278 3.49402 4.41552 3.49402C3.34826 3.49402 2.48157 4.36144 2.48157 5.4287ZM5.26484 5.4287C5.26484 5.89789 4.88471 6.27802 4.41552 6.27802C3.94634 6.27802 3.56621 5.89789 3.56621 5.4287C3.56621 4.95951 3.94634 4.57938 4.41552 4.57938C4.88471 4.57938 5.26484 4.95951 5.26484 5.4287Z" fill="white"/>
                            <path d="M12.4729 2.33706H11.1551V1.02434C11.1551 0.729653 10.8633 0.48999 10.5035 0.48999C10.1436 0.48999 9.85181 0.728929 9.85181 1.02434V2.33706H8.59267C8.3016 2.33706 8.06628 2.62886 8.06628 2.98871C8.06628 3.34857 8.30233 3.64036 8.59267 3.64036H9.85181V4.92629C9.85181 5.22098 10.1436 5.46064 10.5035 5.46064C10.8633 5.46064 11.1551 5.2217 11.1551 4.92629V3.64036H12.4729C12.764 3.64036 12.9993 3.34857 12.9993 2.98871C12.9993 2.62886 12.7632 2.33706 12.4729 2.33706Z" fill="white"/>
                        </g>
                        <defs>
                            <clipPath id="clip0_40_3567">
                            <rect width="12.9309" height="13.02" fill="white" transform="translate(0.0690918 0.48999)"/>
                            </clipPath>
                        </defs>
                    </svg>
                    <span>Solicitar diseño</span>
                </a>
            </div>

            <div class="resources-filters-container">
                <div class="main-tag" @click="filterModal = true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 11 11" fill="none">
                    <g clip-path="url(#clip0_21_21)">
                        <path d="M0 8.9375C0 9.31777 0.307227 9.625 0.6875 9.625H1.8627C2.12695 10.233 2.73281 10.6562 3.4375 10.6562C4.14219 10.6562 4.74805 10.233 5.0123 9.625H10.3125C10.6928 9.625 11 9.31777 11 8.9375C11 8.55723 10.6928 8.25 10.3125 8.25H5.0123C4.74805 7.64199 4.14219 7.21875 3.4375 7.21875C2.73281 7.21875 2.12695 7.64199 1.8627 8.25H0.6875C0.307227 8.25 0 8.55723 0 8.9375ZM2.75 8.9375C2.75 8.75516 2.82243 8.5803 2.95136 8.45136C3.0803 8.32243 3.25516 8.25 3.4375 8.25C3.61984 8.25 3.7947 8.32243 3.92364 8.45136C4.05257 8.5803 4.125 8.75516 4.125 8.9375C4.125 9.11984 4.05257 9.2947 3.92364 9.42364C3.7947 9.55257 3.61984 9.625 3.4375 9.625C3.25516 9.625 3.0803 9.55257 2.95136 9.42364C2.82243 9.2947 2.75 9.11984 2.75 8.9375ZM6.875 5.5C6.875 5.31766 6.94743 5.1428 7.07636 5.01386C7.2053 4.88493 7.38016 4.8125 7.5625 4.8125C7.74484 4.8125 7.9197 4.88493 8.04864 5.01386C8.17757 5.1428 8.25 5.31766 8.25 5.5C8.25 5.68234 8.17757 5.8572 8.04864 5.98614C7.9197 6.11507 7.74484 6.1875 7.5625 6.1875C7.38016 6.1875 7.2053 6.11507 7.07636 5.98614C6.94743 5.8572 6.875 5.68234 6.875 5.5ZM7.5625 3.78125C6.85781 3.78125 6.25195 4.20449 5.9877 4.8125H0.6875C0.307227 4.8125 0 5.11973 0 5.5C0 5.88027 0.307227 6.1875 0.6875 6.1875H5.9877C6.25195 6.79551 6.85781 7.21875 7.5625 7.21875C8.26719 7.21875 8.87305 6.79551 9.1373 6.1875H10.3125C10.6928 6.1875 11 5.88027 11 5.5C11 5.11973 10.6928 4.8125 10.3125 4.8125H9.1373C8.87305 4.20449 8.26719 3.78125 7.5625 3.78125ZM4.125 2.75C3.94266 2.75 3.7678 2.67757 3.63886 2.54864C3.50993 2.4197 3.4375 2.24484 3.4375 2.0625C3.4375 1.88016 3.50993 1.7053 3.63886 1.57636C3.7678 1.44743 3.94266 1.375 4.125 1.375C4.30734 1.375 4.4822 1.44743 4.61114 1.57636C4.74007 1.7053 4.8125 1.88016 4.8125 2.0625C4.8125 2.24484 4.74007 2.4197 4.61114 2.54864C4.4822 2.67757 4.30734 2.75 4.125 2.75ZM5.6998 1.375C5.43555 0.766992 4.82969 0.34375 4.125 0.34375C3.42031 0.34375 2.81445 0.766992 2.5502 1.375H0.6875C0.307227 1.375 0 1.68223 0 2.0625C0 2.44277 0.307227 2.75 0.6875 2.75H2.5502C2.81445 3.35801 3.42031 3.78125 4.125 3.78125C4.82969 3.78125 5.43555 3.35801 5.6998 2.75H10.3125C10.6928 2.75 11 2.44277 11 2.0625C11 1.68223 10.6928 1.375 10.3125 1.375H5.6998Z" fill="black"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_21_21">
                        <rect width="11" height="11" fill="white"/>
                        </clipPath>
                    </defs>
                    </svg>
                    Mis etiquetas
                </div>

                <div class="filter-separator hide-responsive"></div>
                <button  @click="scrollLeft('scrollableContent')" class="scroll-button hide-responsive">
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="14" viewBox="0 0 7 13" fill="none">
                        <path d="M0.256297 7.11785C-0.0854329 6.77612 -0.0854329 6.22115 0.256297 5.87942L5.50527 0.630442C5.847 0.288712 6.40197 0.288712 6.7437 0.630442C7.08543 0.972172 7.08543 1.52714 6.7437 1.86887L2.11258 6.5L6.74097 11.1311C7.0827 11.4729 7.0827 12.0278 6.74097 12.3696C6.39924 12.7113 5.84427 12.7113 5.50254 12.3696L0.253563 7.12058L0.256297 7.11785Z" />
                    </svg>
                </button>

                <div ref="scrollableContent" class="filter-tags-container scroll-component hide-responsive">
                    <div @click="handleFilteringTags(tag)" :class="['single-tag', filteringTags.includes(tag) ? 'selected-tag' : '']" v-for="(tag, index) in allTags" :key="index">
                        {{ tag }}
                    </div>
                    
                </div>
                <button  @click="scrollRight('scrollableContent')" class="scroll-button hide-responsive">
                    <svg xmlns="http://www.w3.org/2000/svg" width="7" height="14" viewBox="0 0 7 13" fill="none">
                        <path d="M6.7437 7.11785C7.08543 6.77612 7.08543 6.22115 6.7437 5.87942L1.49473 0.630442C1.153 0.288712 0.598028 0.288712 0.256297 0.630442C-0.0854327 0.972172 -0.0854327 1.52714 0.256297 1.86887L4.88742 6.5L0.259031 11.1311C-0.082699 11.4729 -0.082699 12.0278 0.259031 12.3696C0.600761 12.7113 1.15573 12.7113 1.49746 12.3696L6.74644 7.12058L6.7437 7.11785Z" />
                    </svg>
                </button>

                <div class="filter-separator"></div>
        
                <div class="input-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 11 11" fill="none">
                        <g clip-path="url(#clip0_53_669)">
                            <path d="M8.9375 4.46875C8.9375 5.45488 8.61738 6.36582 8.07812 7.10488L10.798 9.82695C11.0666 10.0955 11.0666 10.5316 10.798 10.8002C10.5295 11.0688 10.0934 11.0688 9.8248 10.8002L7.10488 8.07812C6.36582 8.61953 5.45488 8.9375 4.46875 8.9375C2.0002 8.9375 0 6.9373 0 4.46875C0 2.0002 2.0002 0 4.46875 0C6.9373 0 8.9375 2.0002 8.9375 4.46875ZM4.46875 7.5625C4.87503 7.5625 5.27733 7.48248 5.65268 7.327C6.02803 7.17153 6.36908 6.94364 6.65636 6.65636C6.94364 6.36908 7.17153 6.02803 7.327 5.65268C7.48248 5.27733 7.5625 4.87503 7.5625 4.46875C7.5625 4.06247 7.48248 3.66017 7.327 3.28482C7.17153 2.90947 6.94364 2.56842 6.65636 2.28114C6.36908 1.99386 6.02803 1.76597 5.65268 1.6105C5.27733 1.45502 4.87503 1.375 4.46875 1.375C4.06247 1.375 3.66017 1.45502 3.28482 1.6105C2.90947 1.76597 2.56842 1.99386 2.28114 2.28114C1.99386 2.56842 1.76597 2.90947 1.6105 3.28482C1.45502 3.66017 1.375 4.06247 1.375 4.46875C1.375 4.87503 1.45502 5.27733 1.6105 5.65268C1.76597 6.02803 1.99386 6.36908 2.28114 6.65636C2.56842 6.94364 2.90947 7.17153 3.28482 7.327C3.66017 7.48248 4.06247 7.5625 4.46875 7.5625Z" />
                        </g>
                    </svg>
                    <input @input="onSearchByName" type="text" placeholder="Buscar imagen por nombre" />
                </div>

                <div v-if="allTags.length > 0" v-show="filterModal" class="re-tags-modal">
                    <div class="resources-header-sect">
                        <span class="re-primary-text">Buscar etiqueta</span>

                        <div class="input-container">
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 11 11" fill="none">
                                <g clip-path="url(#clip0_53_669)">
                                    <path d="M8.9375 4.46875C8.9375 5.45488 8.61738 6.36582 8.07812 7.10488L10.798 9.82695C11.0666 10.0955 11.0666 10.5316 10.798 10.8002C10.5295 11.0688 10.0934 11.0688 9.8248 10.8002L7.10488 8.07812C6.36582 8.61953 5.45488 8.9375 4.46875 8.9375C2.0002 8.9375 0 6.9373 0 4.46875C0 2.0002 2.0002 0 4.46875 0C6.9373 0 8.9375 2.0002 8.9375 4.46875ZM4.46875 7.5625C4.87503 7.5625 5.27733 7.48248 5.65268 7.327C6.02803 7.17153 6.36908 6.94364 6.65636 6.65636C6.94364 6.36908 7.17153 6.02803 7.327 5.65268C7.48248 5.27733 7.5625 4.87503 7.5625 4.46875C7.5625 4.06247 7.48248 3.66017 7.327 3.28482C7.17153 2.90947 6.94364 2.56842 6.65636 2.28114C6.36908 1.99386 6.02803 1.76597 5.65268 1.6105C5.27733 1.45502 4.87503 1.375 4.46875 1.375C4.06247 1.375 3.66017 1.45502 3.28482 1.6105C2.90947 1.76597 2.56842 1.99386 2.28114 2.28114C1.99386 2.56842 1.76597 2.90947 1.6105 3.28482C1.45502 3.66017 1.375 4.06247 1.375 4.46875C1.375 4.87503 1.45502 5.27733 1.6105 5.65268C1.76597 6.02803 1.99386 6.36908 2.28114 6.65636C2.56842 6.94364 2.90947 7.17153 3.28482 7.327C3.66017 7.48248 4.06247 7.5625 4.46875 7.5625Z" />
                                </g>
                                </svg>
                                <input v-model="searchTag" @input="onSearchTag" type="text" placeholder="Buscar etiqueta por nombre" />
                            </div>

                        <button class="close-btn-modal" @click="filterModal = false, copyTags = allTags, searchTag = ''" >
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 8 9" fill="none">
                                <path d="M7.76324 1.86623C8.07559 1.55388 8.07559 1.04662 7.76324 0.734265C7.45088 0.421912 6.94362 0.421912 6.63127 0.734265L4 3.36803L1.36623 0.736764C1.05388 0.42441 0.546619 0.42441 0.234265 0.736764C-0.0780884 1.04912 -0.0780884 1.55638 0.234265 1.86873L2.86803 4.5L0.236764 7.13376C-0.0755895 7.44612 -0.0755895 7.95338 0.236764 8.26573C0.549118 8.57809 1.05638 8.57809 1.36873 8.26573L4 5.63197L6.63376 8.26324C6.94612 8.57559 7.45338 8.57559 7.76573 8.26324C8.07809 7.95088 8.07809 7.44362 7.76573 7.13127L5.13197 4.5L7.76324 1.86623Z" fill="black" fill-opacity="0.15"/>
                            </svg>
                        </button>

                    </div>

                    <div class="classified-tags-container">
                        <div class="classified-tags-item" v-for="(tag, index) in copyTags" :key="index">
                            <span @click="handleFilteringTags(tag)" :class="['single-tag-in-cont', filteringTags.includes(tag) ? 'selected-tag' : '']" >
                                {{ tag }}
                            </span>
                        </div>
                    </div>
                </div>
                
            </div>

            <div v-if="!onSearching" class="cards-main-conatiner scroll-component">
                <div  class="re-cards-container-per-cat" v-for="(cat, index) in mainTags" :key="index" >
                <div v-if="filteredImagesByCat(cat).length > 0" class="re-cards-container-per-cat">
                    <div class="re-title-buttons-container">
                        <span class="re-primary-text">{{cat}} ({{ filteredImagesByCat(cat).length }})</span>
                        <div v-if="filteredImagesByCat(cat).length > 4" class="single-row">
                            <button  @click="scrollLeftContainer(`${cat}`)" class="scroll-button-flat">
                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="14" viewBox="0 0 7 13" fill="none">
                                    <path d="M0.256297 7.11785C-0.0854329 6.77612 -0.0854329 6.22115 0.256297 5.87942L5.50527 0.630442C5.847 0.288712 6.40197 0.288712 6.7437 0.630442C7.08543 0.972172 7.08543 1.52714 6.7437 1.86887L2.11258 6.5L6.74097 11.1311C7.0827 11.4729 7.0827 12.0278 6.74097 12.3696C6.39924 12.7113 5.84427 12.7113 5.50254 12.3696L0.253563 7.12058L0.256297 7.11785Z" />
                                </svg>
                            </button>
                            <button  @click="scrollRightContainer(`${cat}`)" class="scroll-button-flat">
                                <svg xmlns="http://www.w3.org/2000/svg" width="7" height="14" viewBox="0 0 7 13" fill="none">
                                    <path d="M6.7437 7.11785C7.08543 6.77612 7.08543 6.22115 6.7437 5.87942L1.49473 0.630442C1.153 0.288712 0.598028 0.288712 0.256297 0.630442C-0.0854327 0.972172 -0.0854327 1.52714 0.256297 1.86887L4.88742 6.5L0.259031 11.1311C-0.082699 11.4729 -0.082699 12.0278 0.259031 12.3696C0.600761 12.7113 1.15573 12.7113 1.49746 12.3696L6.74644 7.12058L6.7437 7.11785Z" />
                                </svg>
                            </button>
                        </div>
                    </div>
                        <div :ref="`${cat}`" class="re-cards-container scroll-component">
                                <div class="re-card-container" v-for="(card, index) in filteredImagesByCat(cat).sort((a, b) => a.title.localeCompare(b.title))" :key="index" style="max-width: 300px;">
                                    <div class="re-c-image-container" @click="onModal = true, currentDesign = card" >
                                        <img :src="card.image" />
                                        <button class="open-image-button">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 7 8" fill="none">
                                                <path d="M4.375 0.5C4.13301 0.5 3.9375 0.695508 3.9375 0.9375C3.9375 1.17949 4.13301 1.375 4.375 1.375H5.50566L2.75352 4.12852C2.58262 4.29941 2.58262 4.57695 2.75352 4.74785C2.92441 4.91875 3.20195 4.91875 3.37285 4.74785L6.125 1.99434V3.125C6.125 3.36699 6.32051 3.5625 6.5625 3.5625C6.80449 3.5625 7 3.36699 7 3.125V0.9375C7 0.695508 6.80449 0.5 6.5625 0.5H4.375ZM1.09375 0.9375C0.489453 0.9375 0 1.42695 0 2.03125V6.40625C0 7.01055 0.489453 7.5 1.09375 7.5H5.46875C6.07305 7.5 6.5625 7.01055 6.5625 6.40625V4.875C6.5625 4.63301 6.36699 4.4375 6.125 4.4375C5.88301 4.4375 5.6875 4.63301 5.6875 4.875V6.40625C5.6875 6.52656 5.58906 6.625 5.46875 6.625H1.09375C0.973437 6.625 0.875 6.52656 0.875 6.40625V2.03125C0.875 1.91094 0.973437 1.8125 1.09375 1.8125H2.625C2.86699 1.8125 3.0625 1.61699 3.0625 1.375C3.0625 1.13301 2.86699 0.9375 2.625 0.9375H1.09375Z" />
                                            </svg>
                                            Abrir
                                        </button>
                                    </div>

                                    <div class="re-c-tags-cont">
                                        <span @click="handleFilteringTags(tag)" v-for="(tag, index_) in card.tags" :key="index_" class="small-tag">
                                            {{ tag }}
                                        </span>
                                    </div>
                                    <span class="secondary-text">{{ card.title }}</span>
                                    <span class="description-text">{{ card.description }}</span>
                                </div>
                        </div>
                    </div>
                </div>
                

            </div>

            <div v-else style="width: 100%;">
                <div v-if="imagesCopy.length > 0" class="browsing-cards-container scroll-component">
                    <div  class="re-card-container" v-for="(card, index) in imagesCopy" :key="index">
                        <div class="re-c-image-container" @click="onModal = true, currentDesign = card">
                            <img :src="card.image" />
                            <button class="open-image-button">
                                <svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 7 8" fill="none">
                                    <path d="M4.375 0.5C4.13301 0.5 3.9375 0.695508 3.9375 0.9375C3.9375 1.17949 4.13301 1.375 4.375 1.375H5.50566L2.75352 4.12852C2.58262 4.29941 2.58262 4.57695 2.75352 4.74785C2.92441 4.91875 3.20195 4.91875 3.37285 4.74785L6.125 1.99434V3.125C6.125 3.36699 6.32051 3.5625 6.5625 3.5625C6.80449 3.5625 7 3.36699 7 3.125V0.9375C7 0.695508 6.80449 0.5 6.5625 0.5H4.375ZM1.09375 0.9375C0.489453 0.9375 0 1.42695 0 2.03125V6.40625C0 7.01055 0.489453 7.5 1.09375 7.5H5.46875C6.07305 7.5 6.5625 7.01055 6.5625 6.40625V4.875C6.5625 4.63301 6.36699 4.4375 6.125 4.4375C5.88301 4.4375 5.6875 4.63301 5.6875 4.875V6.40625C5.6875 6.52656 5.58906 6.625 5.46875 6.625H1.09375C0.973437 6.625 0.875 6.52656 0.875 6.40625V2.03125C0.875 1.91094 0.973437 1.8125 1.09375 1.8125H2.625C2.86699 1.8125 3.0625 1.61699 3.0625 1.375C3.0625 1.13301 2.86699 0.9375 2.625 0.9375H1.09375Z" />
                                </svg>
                                Abrir
                            </button>
                        </div>
                        <div class="re-c-tags-cont">
                            <span @click="handleFilteringTags(tag)" v-for="(tag, index_) in card.tags" :key="index_" class="small-tag">
                                {{ tag }}
                            </span>
                        </div>
                        <span class="secondary-text">{{ card.title }}</span>
                        <span class="description-text">{{ card.description }}</span>
                    </div>
                </div>
                <div v-else class="nodata-main-cont">
                    <div class="no-data-image-cont">
                        <img src="../../assets/no-data.jpg" />
                    </div>
                </div>
            </div>

            

          </div>

          <div v-show="onModal" class="open-res-modal">
                <div class="open-res-modal-container" >
                    <div class="modal-warning-header">
                        <div class="single-row">
                            <img src="../../assets/warning_sign.png" />
                            <span class="modal-main-text">Aviso</span>
                        </div>
                    
                        <div class="single-row buttons-container">
                        
                        <a v-if="currentDesign" :href="currentDesign.url" target="_blank" class="re-cta-second-button" style="min-width: 80px;">
                            <span style="color: #F35431;" >Abrir</span>
                        </a>
                        <div @click="onModal = false, currentDesign = null" class="re-second-button">
                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 8 9" fill="none">
                                <path d="M7.76324 1.86623C8.07559 1.55388 8.07559 1.04662 7.76324 0.734265C7.45088 0.421912 6.94362 0.421912 6.63127 0.734265L4 3.36803L1.36623 0.736764C1.05388 0.42441 0.546619 0.42441 0.234265 0.736764C-0.0780884 1.04912 -0.0780884 1.55638 0.234265 1.86873L2.86803 4.5L0.236764 7.13376C-0.0755895 7.44612 -0.0755895 7.95338 0.236764 8.26573C0.549118 8.57809 1.05638 8.57809 1.36873 8.26573L4 5.63197L6.63376 8.26324C6.94612 8.57559 7.45338 8.57559 7.76573 8.26324C8.07809 7.95088 8.07809 7.44362 7.76573 7.13127L5.13197 4.5L7.76324 1.86623Z" fill="#FFF"/>
                            </svg>
                        </div>
                    </div>
                    </div>
                    <span class="modal-single-text">En caso de ser un editable, solo está permitido modificar el texto. <b>No muevas, recortes ni modifiques la imagen original.</b> Agradecemos su comprensión y colaboración.</span>
                    <div style="align-self: stretch; display: flex; padding: 0px 24px;">
                        <div v-if="currentDesign" class="modal-image-container">
                            <img :src="currentDesign.image" />
                        </div>
                    </div>
                    
                    
                    
                    
                </div>
          </div>
    </div>
  </div>
</template>


<script>
import {
  getFirestore,
  getDocs,
  collection,
} from "firebase/firestore";
export default {
  components: {},
  data() {
    return {
        user: null,
        imagesCopy: [],
        // images: 
        // [
        //     {
        //         "title": "Diseño de firmas digitales",
        //         "tags": ["CxC", "Presentaciones", "Avisos"],
        //         "url": "",
        //         "image": "",
        //         "description": "Documento con estructura profesional para uso corporativo."
        //     },
        //     {
        //         "title": "Post para LinkedIn sobre nuevos empleados",
        //         "tags": ["Canplast", "CxC"],
        //         "url": "",
        //         "image": "",
        //         "description": "Plantilla visual optimizada para historias de redes sociales."
        //     },
        //     {
        //         "title": "Diseño de firmas digitales",
        //         "tags": ["DEV/TI", "Promociones", "Documentos"],
        //         "url": "",
        //         "image": "",
        //         "description": "Documento con estructura profesional para uso corporativo."
        //     },
        //     {
        //         "title": "Diseño de firmas digitales",
        //         "tags": ["CxC", "Logos", "Canplast"],
        //         "url": "",
        //         "image": "",
        //         "description": "Publicación digital para atraer la atención de empleados."
        //     },
        //     {
        //         "title": "Invitación a evento corporativo",
        //         "tags": ["DEV/TI", "Avisos"],
        //         "url": "",
        //         "image": "",
        //         "description": "Diseño adaptable a distintos canales de comunicación."
        //     },
        //     {
        //         "title": "Story de aniversario empresarial",
        //         "tags": ["CxC", "Avisos"],
        //         "url": "",
        //         "image": "",
        //         "description": "Banner digital con imagen corporativa y mensaje claro."
        //     },
        //     {
        //         "title": "Publicidad para redes sociales",
        //         "tags": ["CxC", "Firmas"],
        //         "url": "",
        //         "image": "",
        //         "description": "Banner digital con imagen corporativa y mensaje claro."
        //     },
        //     {
        //         "title": "Tarjeta de presentación digital",
        //         "tags": ["Canplast", "Firmas"],
        //         "url": "",
        //         "image": "",
        //         "description": "Documento digital con información clave bien estructurada."
        //     },
        //     {
        //         "title": "Flyer para promociones de RRHH",
        //         "tags": ["DEV/TI", "Presentaciones", "Fondos"],
        //         "url": "",
        //         "image": "",
        //         "description": "Flyer atractivo con detalles de promoción, fechas y requisitos."
        //     },
        //     {
        //         "title": "Post para LinkedIn sobre nuevos empleados",
        //         "tags": ["CxC", "Presentaciones", "Firmas"],
        //         "url": "",
        //         "image": "",
        //         "description": "Imagen creativa para captar la atención del público objetivo."
        //     },
        //     {
        //         "title": "Fondo de pantalla corporativo",
        //         "tags": ["RRHH", "Formatos", "CxC"],
        //         "url": "",
        //         "image": "",
        //         "description": "Banner digital con imagen corporativa y mensaje claro."
        //     },
        //     {
        //         "title": "Historia para Instagram de promociones",
        //         "tags": ["CxC", "Formatos"],
        //         "url": "",
        //         "image": "",
        //         "description": "Publicación diseñada para atraer más interacciones."
        //     },
        //     {
        //         "title": "Flyer para promociones de RRHH",
        //         "tags": ["CxC", "Documentos", "Presentaciones"],
        //         "url": "",
        //         "image": "",
        //         "description": "Plantilla visual optimizada para historias de redes sociales."
        //     },
        //     {
        //         "title": "Anuncio de nuevo colaborador",
        //         "tags": ["Canplast", "CxC", "Vacantes"],
        //         "url": "",
        //         "image": "",
        //         "description": "Banner digital con imagen corporativa y mensaje claro."
        //     },
        //     {
        //         "title": "Anuncio de nuevo colaborador",
        //         "tags": ["DEV/TI", "CxC"],
        //         "url": "",
        //         "image": "",
        //         "description": "Formato profesional para comunicar nuevas iniciativas."
        //     },
        //     {
        //         "title": "Diseño de firmas digitales",
        //         "tags": ["CxC", "Firmas"],
        //         "url": "",
        //         "image": "",
        //         "description": "Flyer con diseño llamativo que muestra detalles relevantes."
        //     },
        //     {
        //         "title": "Invitación a evento corporativo",
        //         "tags": ["Canplast", "Promociones"],
        //         "url": "",
        //         "image": "",
        //         "description": "Publicación diseñada para atraer más interacciones."
        //     },
        //     {
        //         "title": "Aviso de nuevas vacantes",
        //         "tags": ["RRHH", "Anuncios", "Fondos"],
        //         "url": "",
        //         "image": "",
        //         "description": "Diseño profesional para anunciar eventos internos o externos."
        //     },
        //     {
        //         "title": "Diseño de firmas digitales",
        //         "tags": ["Canplast", "Logos", "Vacantes"],
        //         "url": "",
        //         "image": "",
        //         "description": "Imagen adaptada para avisos internos y comunicados oficiales."
        //     },
        //     {
        //         "title": "Formato para comunicados internos",
        //         "tags": ["Canplast", "Avisos"],
        //         "url": "",
        //         "image": "",
        //         "description": "Documento con estructura profesional para uso corporativo."
        //     }
        //     ],
        images: [],
        filterModal: false,
        onSearching: false,
        onModal:false,
        currentDesign: null,
        searchTag: '',
        mainTags: [],
        allTags:[],
        filteringTags: [],
        copyTags: [],
        classifiedTags: [
            {
                name: 'Canplast',
                tags: [
                    'Logos',
                    'Fondos',
                    'Tipografías',
                    'Documentos',
                    'Presentaciones',
                    'Formatos'
                ]
            },
            {
                name: 'RRHH',
                tags: [
                    'Vacantes',
                    'Aniversarios',
                    'Nuevos',
                    'Cumpleaños',
                    'Promociones',
                    'Avisos'
                ]
            },
            {
                name: 'DEV/TI',
                tags: [
                    'Logos',
                    'Wallpapers',
                    'Avisos',
                    'Firmas',
                ]
            },
            {
                name: 'CxC',
                tags: [
                    'Firmas',
                    'Anuncios',
                    'Stories',
                    'Publicaciones',
                ]
            }
        ],
    };
  },

  methods: {
    filteredImagesByCat(cat) {
        return this.images.filter(img => img.tags && img.tags.includes(cat));
    },
    handleFilteringTags(tag) {
        const index = this.filteringTags.indexOf(tag);

        if (index !== -1) {
            this.filteringTags.splice(index, 1);
        } else {
            this.filteringTags.push(tag);
        }
        this.imagesCopy = this.images.filter(image => {
            return this.filteringTags.length === 0 || 
                (Array.isArray(image.tags) && image.tags.some(tag => this.filteringTags.includes(tag)));
        });

        // this.imagesCopy = this.images.filter(image => {
        //     return this.filteringTags.length === 0 || 
        //         (Array.isArray(image.tags) && this.filteringTags.every(tag => image.tags.includes(tag)));
        // });
        this.onSearching = this.filteringTags.length > 0;

    },
    scrollRight(refName) {
        const container = this.$refs[refName];
        if (container) {
            container.scrollBy({ left: 300, behavior: "smooth" });
        }
    },
    scrollLeft(refName) {
        const container = this.$refs[refName];
        if (container) {
            container.scrollBy({ left: -300, behavior: "smooth" });
        }
    },
    scrollRightContainer(refName) {
        const container = this.$refs[refName];
        if (container) {
            container[0].scrollBy({ left: 1000, behavior: "smooth" });
        }
    },
    scrollLeftContainer(refName) {
        const container = this.$refs[refName];
        if (container) {
            container[0].scrollBy({ left: -1000, behavior: "smooth" });
        }
    },
    onSearchTag(e) {
        const value = e.target.value.toLowerCase()
        this.copyTags = this.allTags.filter((tag) => tag.toLowerCase().includes(value))
    },
    onSearchByName(e) {
        const value = e.target.value.trim().toLowerCase();
        this.imagesCopy = this.images.filter(image => 
            image.title && image.title.toLowerCase().includes(value)
        );
        this.onSearching = value.length > 0;
    }
  },
  computed: { 
    
  },
  created() {
    const db = getFirestore();
    const reqColImages = collection(db, "graphic_resources");
    const reqColTags = collection(db, "graphic_resources_tags");
    Promise.all([
        getDocs(reqColImages),
        getDocs(reqColTags)
    ])
    .then(([imagesSnapshot, tagsSnapshot]) => {

        if (!imagesSnapshot.empty) {
            this.images = imagesSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
        } else {
            console.log("No se encontraron documentos en la colección graphic_resources");
        }
        if (!tagsSnapshot.empty) {
            const tags = tagsSnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            }));
            this.allTags = tags.map(tag => tag.value);
            this.mainTags = tags
                .filter(tag => tag.isDep === true)
                .map(tag => tag.value);

             // Contamos las imágenes por cada mainTag
            const mainTagCounts = {};
            this.mainTags.forEach(tag => {
                const count = this.images.filter(image => image.tags && image.tags.includes(tag)).length;
                mainTagCounts[tag] = count;
            });

            // Ordenamos mainTags de mayor a menor cantidad, dejando Canplast al inicio siempre
            this.mainTags = this.mainTags.sort((a, b) => {
                if (a === "Canplast") return -1;
                if (b === "Canplast") return 1;
                return mainTagCounts[b] - mainTagCounts[a];
            });

            // console.log("Main tags ordenados:", this.mainTags);

            this.copyTags = this.allTags
            this.imagesCopy = this.images
        } else {
            console.log("No se encontraron documentos en la colección graphic_resources_tags");
        }
    })
    .catch((error) => {
        console.error("Error al obtener documentos:", error);
    });

  },

};
</script>


<style>

    /* * {
        font-family: "Work Sans";
    } */

    .scroll-component::-webkit-scrollbar {
        width: 0px; 
        height: 0px; 
    }

    .nodata-main-cont {
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        height: 68vh;
    }
    
    .no-data-image-cont {
        /* width: 60vw; */
        height: 350px;

    }

    .no-data-image-cont img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        
    }
    .single-row {
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 16px;
    }

    .resources-main-container {
        
        border-radius: 18px;
        padding: 24px;
        display: flex;
        align-items: flex-start;
        align-self: stretch;
        flex-direction: column;
        /* gap: 24px; */
    }

    .resources-header-sect {
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 22px;
        padding-bottom: 24px;
    }

    .re-primary-text {
        color: #1E1E1E;
        font-size: 18px;
        font-weight: 600;
    }

    .re-cta-button,
    .re-cta-second-button,
    .re-second-button {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 8px 12px;
        gap: 8px;
        border-radius: 8px;
        background: linear-gradient(270deg, #F35431 0%, #F33250 100%);
        cursor: pointer;
        transition: all 0.3s ease;
        color: #FFF;
        font-size: 14px;
        font-weight: 500;
        min-height: 33px;
    }

    .re-cta-button svg {
        color: #FFF;
    }

    .re-cta-button:hover {
        background: linear-gradient(0deg, #F35431 0%, #F33250 100%);
        color: #FFF;
    }

    

    .re-cta-second-button {
        background: #FFF;
        color: #F35431;
    }

    .re-second-button {
        background: transparent;
        outline: 2px solid #FFF;
        color: #FFF;
        /* min-width: 130px; */
    }

    .resources-filters-container {
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 14px;
        padding-bottom: 24px;
        border-bottom: 1px solid #F0F0F0;
        position: relative;
    }

    .main-tag,
    .single-tag {
        display: flex;
        padding: 6px 10px;
        align-items: center;
        gap: 8px;
        border-radius: 16px;
        border: 1px solid #F0F0F0;
        background: #FBFBFB;
        color: #1E1E1E;
        font-size: 13px;
        font-weight: 400;
        cursor: pointer;
        transition: all 0.3s ease;
        max-height: 33px;
    }

    .main-tag {
        min-width: 130px;
    }


    .main-tag:hover,
    .single-tag:hover,
    .single-tag-in-cont:hover {
        background: #F1F1F1;
    }

    .single-tag-in-cont {
        align-self: stretch;
        cursor: pointer;
        padding: 8px;
        border: 1px solid #F0F0F0;
        background: #FBFBFB;
        border-radius: 8px;
        text-align: center;
        color: #000;
        font-size: 14px;

    }

    .selected-tag {
        background: linear-gradient(270deg, #F35431 0%, #F33250 100%);
        color: #FFF;
        font-weight: 400;
        border: none;
        transition: all 0.3s ease;
    }

    .selected-tag:hover {
        background: linear-gradient(90deg, #F35431 0%, #F33250 100%);
    }

    .filter-separator {
        width: 1px;
        height: 27px;
        background-color: #F0f0f0;
    }

    .filter-tags-container {
        max-width: 40vw;
        overflow: auto;
        display: flex;
        align-self: center;
        justify-content: flex-start;
        gap: 7px;
    }

    .input-container {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 16px;
        border-radius: 16px;
        border: 1px solid #F0F0F0;
        padding: 0px 12px;
        min-height: 33px;
        min-width: 350px;
        transition: all 0.1s ease;
    }

    .input-container input {
        border: none;
        outline: none;
        width: 100%;
        font-weight: 400;
        font-size: 14px;
    }

    .input-container input:hover,
    .input-container input:active,
    .input-container input:focus {
        border: none !important;
        outline: none !important;
    }

    .input-container input::placeholder {
        color: #CACACA;
        font-style: italic;
        font-weight: 300;
    }

    .input-container svg {
        fill: #CACACA;
    }

    .input-container:focus-within {
        outline: 2px solid #F54D49;
    }

    .input-container:focus-within svg {
        fill:  #F54D49;
    }

    .scroll-button,
    .scroll-button-flat {
        height: 33px;
        min-width: 33px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 40px;
        border: 1px solid #F0F0F0;
        background-color: #FBFBFB;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .scroll-button-flat {
        height: 25px;
        width: 60px;
        min-width: none;
        border-radius: 6px;
    }

    .scroll-button svg,
    .scroll-button-flat svg {
        fill: #CACACA;
    }

    .scroll-button:hover,
    .scroll-button-flat:hover {
        background-color: #F54D49;
        border: 1px solid #F54D49;
    }

    .scroll-button:hover svg,
    .scroll-button-flat:hover svg {
        fill: #FFF !important;
    }

    .scroll-button:active,
    .scroll-button:focus,
    .scroll-button-flat:active,
    .scroll-button-flat:focus {
        outline: none;
    }

    .re-tags-modal {
        position: absolute;
        left: 0px;
        top: 0px;
        /* width: 850px; */
        /* height: 500px; */
        border-radius: 12px;
        background-color: #FFF;
        box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        padding: 18px;
        gap: 16px;
        z-index: 5;
    }

    .close-btn-modal  {
        background-color: transparent;
        border: none;
    }

    .close-btn-modal:hover {
        background-color: #FBFBFB;
        outline: none;
    }

    .close-btn-modal:active,
    .close-btn-modal:focus {
        outline: none;
    }

    .classified-tags-container,
    .browsing-cards-container {
        align-self: stretch;
        display: grid;
        grid-template-columns: repeat(4, 1fr); /* 4 columnas del mismo tamaño */
        gap: 12px; 
        padding-top: 24px;
        border-top: 1px solid #F0F0F0;
    }

    .browsing-cards-container {
        border: none;
        padding: 0px;
        gap: 24px;
        padding-top: 24px;
        grid-template-columns: repeat(4, 1fr);
        max-height: 68vh;
        overflow-y: auto;
    }
    

    .classified-tags-item {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        gap: 16px;
    }

    .cards-main-conatiner{
        align-self: stretch;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        gap: 12px;
        max-height: 68vh;
        padding-top: 24px;
        overflow-y: auto;
    }

    .re-title-buttons-container {
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .re-cards-container-per-cat {
        align-self: stretch;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        gap: 14px;
        
    }

    .re-cards-container {
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 14px;
        width: 100%;
        overflow-x: auto;
        padding: 2px 0px;
    }

    .re-card-container {
        min-width: 300px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        flex-direction: column;
        gap: 8px;
    }

    .re-c-image-container {
        display: flex;
        height: 136px;
        border-radius: 8px;
        align-self: stretch;  
        position: relative;
        background-color: #FBFBFB;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        /* box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2); */
        border: 1px solid #F0F0F0;
    }

    .re-c-image-container img {
        position: absolute;
        top: 0px;
        width: 100%;
        height: 100%;
        /* height: 100%; */
        object-fit: cover;
    }

    .re-c-tags-cont {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 5px;
        padding-top: 4px;
    }

    .small-tag {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 2px 7px;
        border-radius: 6px;
        border: 1px solid #F0F0F0;
        background: #FBFBFB;
        color: #BBB;
        font-size: 12px;
        font-weight: 400;
        cursor: pointer;
        transition: all 0.15s ease;

    }

    .small-tag:hover {
        background-color: #FFFFFF;
        border: 1px solid #F54D49;
        color: #F54D49;
    }

    .secondary-text {
        color: #000;
        font-size: 16px;
        font-weight: 600;
        line-height: 16px;
    }

    .description-text {
        color: #8B8B8B;
        font-size: 13px;
        font-weight: 400;
        line-height: 14px; /* 140% */
    }

    .open-image-button {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        gap: 6px;
        border-radius: 5px;
        background-color: #F0F0F080;
        backdrop-filter: blur(4px);
        border: none;
        position: absolute;
        top: 10px;
        right: 10px;
        padding: 4px 6px;
        transition: all 0.3s ease;
        color: #000;
        font-size: 12px;
        font-weight: 500;
        /* border: 1px solid #F0F0F0; */
    }

    .open-image-button svg {
        fill: #000;
        transition: all 0.3s ease;
    }

    .open-image-button:hover {
        background-color: #F54D4999;
        color: #FFF;
        /* border: 1px solid #F54D49; */
        box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
    }

    .open-image-button:hover svg {
        fill: #FFF;;
    }

    .open-image-button:active,
    .open-image-button:focus {
        outline: none !important;
    }

    .open-res-modal {
        width: 100%;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        background-color: #00000080;
        z-index: 99;
        padding-top: 100px;
    }

    .open-res-modal-container {
        width: 650px;
        /* height: 300px; */
        border-radius: 12px;
        box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2);
        background-color: #FFF;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        flex-direction: column;
        overflow: hidden;
        gap: 24px;
        padding-bottom: 24px;
    }

    .modal-warning-header {
        align-self: stretch;
        height: 70px;
        background: linear-gradient(270deg, #F35431 0%, #F33250 100%);
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0px 24px;
        gap: 12px;
    }

    .modal-warning-header img {
        max-height: 30%;
    }

    .modal-main-text {
        font-size: 28px;
        font-weight: 500;
        line-height: 1.2;
        color: #FFF;
        /* margin-bottom: -16px; */
    }

    .modal-image-container {
        width: 100%;
        max-height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        /* border: 1px solid #F0F0F0; */
        border-radius: 6px;
        box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.2);
        overflow: hidden;
        background-color: #F5F5F5;
    }

    .modal-image-container img {
        width: 100%;
        object-fit: cover;
    }

    .modal-single-text {
        font-size: 18px;
        font-weight: 400;
        line-height: 1.2;
        color: #000;
        text-align: left;
        padding: 0px 24px;
    }

    .buttons-container {
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        /* padding: 0px 24px; */
    }
    

    @media screen and (max-width: 1000px) {
        .hide-responsive {
            display: none;
        }

        .input-container {
            min-width: 50px;
        }
    }


   


</style>
